<template>
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    @click="handleShare"
  >
    <title>各配色切图&amp;色值</title>
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="各配色切图&amp;色值" transform="translate(-173, -632)">
        <g id="分享" transform="translate(173, 632)">
          <rect
            id="矩形"
            fill="#FFFFFF"
            x="0"
            y="0"
            width="26"
            height="26"
            rx="13"
          ></rect>
          <path
            d="M19.317942,6.00007544 L15.2269174,6.00007544 C15.0389765,6.00007544 14.8779473,6.0663329 14.7451533,6.20001174 C14.6141135,6.32636531 14.5415502,6.50154331 14.5448594,6.68354981 C14.5448594,6.87105317 14.6110358,7.03120308 14.7451533,7.16444077 C14.8775061,7.29811963 15.0389765,7.36473846 15.2269174,7.36473846 L17.6714733,7.36473846 L12.0142742,13.020722 C11.8843543,13.1466185 11.8131452,13.3212043 11.8179509,13.5020541 C11.8179509,13.6961753 11.8828038,13.8585311 12.0120683,13.9873569 C12.1413329,14.1188299 12.3041268,14.183684 12.4995677,14.183684 C12.6914793,14.183684 12.8529497,14.1170652 12.9844201,13.985151 L18.635884,8.32916749 L18.635884,10.7733289 C18.635884,10.9625969 18.7020604,11.1231881 18.8357367,11.2564257 C18.9689718,11.3896634 19.1295599,11.4562823 19.317942,11.4562822 C19.5058829,11.4562822 19.6669121,11.3901046 19.7997061,11.2564257 C19.9333824,11.1231881 20,10.9625969 20,10.7728877 L20,6.68310863 C20,6.49604646 19.9338236,6.33324943 19.7997061,6.20001174 C19.6736393,6.06967379 19.4992489,5.99732913 19.317942,6.00007544 Z M11.7491275,6.0376559 C10.8363344,6.12677515 9.94868842,6.38575036 9.13074822,6.80002249 C7.48476869,7.62846337 6.20048112,9.03272831 5.52192898,10.7459754 C5.17564632,11.6228997 4.99855607,12.5574691 5.00000887,13.5002894 C5.00000887,14.5189841 5.1972235,15.4917956 5.59075243,16.4191651 C5.95692847,17.2962397 6.49163371,18.0921363 7.19442699,18.804649 C7.90780848,19.5087792 8.70368991,20.0421711 9.58074769,20.4087953 C10.5072172,20.8023318 11.4800101,20.9999912 12.4995677,20.9999912 C13.442166,21.0014358 14.3764812,20.8240307 15.2529468,20.4771789 C16.0986203,20.1428732 16.8766515,19.6579584 17.5492676,19.0459768 C18.2281234,18.4274034 18.7878168,17.6896049 19.2005892,16.8691732 C19.6138173,16.0513026 19.8719947,15.1639692 19.9620589,14.2520676 C19.9797059,14.0477992 19.922353,13.872649 19.7886767,13.7226463 C19.6604525,13.5767993 19.4741339,13.495354 19.2800009,13.5002894 C19.1061775,13.5002894 18.954413,13.5585257 18.8247073,13.6749984 C18.6941192,13.7919123 18.620884,13.939709 18.603237,14.1126533 C18.5314263,14.8602004 18.3212361,15.5878761 17.9833848,16.258574 C17.6461096,16.9310953 17.1859884,17.5345764 16.6267687,18.0378706 C16.0806789,18.5426788 15.4446605,18.9404598 14.7517709,19.2105386 C14.0342983,19.4926461 13.2700659,19.636934 12.4991266,19.6358403 C11.6644217,19.6358403 10.8689814,19.4752492 10.1123647,19.1567141 C9.3950126,18.8545028 8.74339574,18.414642 8.15751408,17.8397788 C7.58222064,17.2543272 7.14369177,16.6044626 6.84236858,15.8853321 C6.52259483,15.1310005 6.35929674,14.3195976 6.36236916,13.5002894 C6.36236916,12.7229225 6.50442782,11.9711444 6.78810395,11.2458373 C7.05752651,10.5527087 7.45520641,9.91658833 7.96030843,9.37080377 C8.97551314,8.2445302 10.3760444,7.53976478 11.8854508,7.39562138 C12.0597153,7.37709164 12.2053034,7.30429622 12.322215,7.17282327 C12.4395678,7.04399743 12.4986854,6.89178884 12.4986854,6.71884456 C12.4986854,6.58340095 12.4730972,6.46869302 12.4210384,6.37295602 C12.3749822,6.28318553 12.3038734,6.2087037 12.2163328,6.15854042 C12.1398251,6.11638686 12.0582969,6.08407144 11.973686,6.06236223 C11.8992775,6.04536384 11.8232446,6.03648823 11.7469216,6.03589117 L11.7486863,6.0376559 L11.7491275,6.0376559 Z"
            id="形状"
            fill="transparent"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "ShareSvg",
  props: {
    componentConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      const color = this.componentConfig.backgroundColor;
      this.$el.querySelector("path").setAttribute("fill", color);
    },
    // 分享功能
    handleShare() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_share_click",
        shareType: "BCOP运营活动H5",
        shareId: this.$route.params.pageId,
      });
      function getBase64(src) {
        return new Promise((resolve, reject) => {
          const img2 = new Image();
          img2.crossOrigin = "Anonymous"; // 设置跨域属性
          img2.src = src;
          img2.onload = function () {
            const canvas2 = document.createElement("canvas");
            const ctx2 = canvas2.getContext("2d");
            canvas2.width = img2.width;
            canvas2.height = img2.height;
            ctx2.drawImage(img2, 0, 0);
            const base64 = canvas2.toDataURL("image/png");
            resolve(base64);
          };
          img2.onerror = function (e) {
            console.log(e);
            reject(e);
          };
        });
      }
      const { shareTitle, shareIcon, shareDescription } = this.componentConfig;
      const pageId = this.$route.params.pageId;
      const currentHref = window.location.href;
      const currentQuery = window.location.search.split("?")[1];

      // AI 助手分享用
      if (this.$route.name == "Ai" || this.$route.name == "AiSub") {
        let data = {
          share_url: `${location.origin}/Ai${location.search}`,
          sharetxt: shareDescription,
          share_img: shareIcon,
          sharetitle: shareTitle,
        };
        this.$jsBridge.appShare(data).then((result) => {
          console.log("appShare result", result);
        });
        return false;
      }

      const path =
        currentHref.indexOf("?") > -1
          ? `${currentHref}&utm_source=bcop&utm_medium=share&utm_campaign=${pageId}`
          : `${currentHref}?utm_source=bcop&utm_medium=share&utm_campaign=${pageId}`;

      const appShare = (base64) => {
        let data = {
          share_url: path,
          sharetxt: shareDescription,
          share_img: shareIcon,
          sharetitle: shareTitle,
        };
        if (base64) {
          data = {
            ...data,
            mini_program_title: shareTitle,
            mini_program_path: `pages/op/index?id=${pageId}&utm_source=bcop&utm_medium=share&utm_campaign=${pageId}&${currentQuery}`,
            mini_program_image: base64,
            sharePlatform: ["WXSession", "WXTimeline"],
            shareType: "BCOP运营活动H5",
          };
        }
        this.$jsBridge.appShare(data).then((result) => {
          console.log("appShare result", result);
        });
      };
      getBase64(shareIcon)
        .then((res) => {
          let base64 = "";
          if (res) {
            base64 = res.replace("data:image/png;base64,", "");
            appShare(base64);
          }
        })
        .catch((e) => {
          console.log(e);
          appShare();
        });
    },
  },
};
</script>
